// Lib imports
import React from "react";

// Util imports
import urlGenerator from "src/utils/urlGenerator";
import { humanDate } from "src/utils/dateHandler";

// Component imports
import ActiveLink from "src/components/layouts/ActiveLink";
import Skeleton from "src/components/elements/Skeleton";

// Style imports
import styles from "src/styles/components/pages/category/faqsListing.module.scss";

const FaqsListing = React.memo(({ faqs, categorySlug }) => {
  return (
    <div className={styles.browse_topic}>
      <ul>
        {faqs?.docs?.length > 0
          ? faqs.docs.map(({ title, answer, updatedAt, _id, slug }) => (
              <li key={_id}>
                <ActiveLink
                  activeClassName={styles.active}
                  href={urlGenerator.faqLink(categorySlug, slug)}
                  scroll={false}
                >
                  <div className={styles.linkContent}>
                    <h3 className="ucfirst">{title}</h3>
                    <p className="ucfirst">{answer}</p>
                    {/* <div className={styles.info_bar}>
                      <span className={styles.info_date}>
                        {humanDate(updatedAt)}
                      </span>
                    </div> */}
                    <div className={styles.grey_divider}></div>
                  </div>
                </ActiveLink>
              </li>
            ))
          : [...Array(6)].map((_, index) => (
              <li key={index}>
                <h3>
                  <Skeleton width={200} />
                </h3>
                <p>
                  <Skeleton count={2} />
                </p>
                <div className={styles.info_bar}>
                  <span className={styles.info_date}>
                    <Skeleton width={75} />
                  </span>
                </div>
                <div className={styles.grey_divider}></div>
              </li>
            ))}
      </ul>
    </div>
  );
});

FaqsListing.displayName = "FaqsListing";

export default FaqsListing;
